import { useMutation, useQueryClient } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useNavigate } from 'libs/router'
import { FieldValues, UseFormSetError } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { queryKeys } from 'config/queryKeys'

export const useCreateUserMutation = (setError: UseFormSetError<FieldValues>) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	const { mutate: createUser, isPending: isCreateUserLoading } = useMutation({
		mutationFn: (data) => {
			// TODO: change to apiRoutes
			return axiosPrivate.post('/accounts/', data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
			useToast({ type: 'success', message: t('User created') })()

			// TODO: change to routes
			navigate('/users')
		},
		onError: (res: any) => {
			if (res?.response?.data) {
				for (const [key, value] of Object.entries(res.response.data)) {
					setError(key, { message: value as string })
				}
			}

			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		createUser,
		isCreateUserLoading
	}
}
